import {Component, Input, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {DeviceParamLirisV3} from '../../../../../../shared/classes/device/type-v3/device-param-liris-v3';
import {FormGroup, FormControl} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-param-other',
  templateUrl: './param-other.component.html',
  styleUrls: ['./param-other.component.css']
})
export class ParamOtherComponent implements OnInit {

  othersForm: FormGroup;
  unblockBluetoothName: boolean = false;
  @Input('deviceParamLirisV3') deviceParamLirisV3: DeviceParamLirisV3;
  @Input('editable') editable: boolean = true;
  @Input('sensorType') sensorType: number;

  constructor(private toastr: ToastrService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    let measurementMode = this.deviceParamLirisV3.MeasurementMode;
    if (measurementMode === 0) {
      measurementMode = 'Dynamic';
    } else if (measurementMode === 1) {
      measurementMode = 'Static';
    }
      this.othersForm = new FormGroup({
        bluetoothName: new FormControl(this.deviceParamLirisV3.bluetoothName),
        periodAcq: new FormControl(this.deviceParamLirisV3.periodAcq),
        staticRecordPeriod: new FormControl(this.deviceParamLirisV3.staticRecordPeriod),
        boardType_extension: new FormControl(this.deviceParamLirisV3.boardType.extension),
        MeasurementMode: new FormControl(measurementMode),
      });
    if (this.deviceParamLirisV3.bluetoothName == undefined) {
      this.unblockBluetoothName = true;
    }
  }

  setDeviceWithForm() {
    this.deviceParamLirisV3.bluetoothName = this.othersForm.value.bluetoothName;
    this.deviceParamLirisV3.periodAcq = this.othersForm.value.periodAcq;
    this.deviceParamLirisV3.staticRecordPeriod = this.othersForm.value.staticRecordPeriod;
    this.deviceParamLirisV3.boardType.extension = this.othersForm.value.boardType_extension;
    if (this.sensorType === 18) {
      this.deviceParamLirisV3.MeasurementMode = this.othersForm.value.MeasurementMode === 'Static' ? 1 : 0;
    }
  }
}
